export default __webpack_public_path__ + "static/media/web_screen_engage_en.c5c0ea8c.png";